import { LONGITUDE_REGEX_PATTERN, LATITUDE_REGEX_PATTERN, START_WITH_SPACE } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const PosCreateSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>)
    .max(255, <Translation>{(t) => t('VALIDATE.MAX_NAME')}</Translation>),
  address: Yup.string()
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_ADDRESS')}</Translation>)
    .max(255, <Translation>{(t) => t('VALIDATE.MAX_ADDRESS')}</Translation>),
  city: Yup.string()
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_CITY')}</Translation>)
    .max(255, <Translation>{(t) => t('VALIDATE.MAX_CITY')}</Translation>)
    .matches(START_WITH_SPACE, {
      message: <Translation>{(t) => t('VALIDATE.REQUIRED_CITY')}</Translation>,
    }),
  longitude: Yup.string()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_LONGITUDE')}</Translation>)
    .matches(LONGITUDE_REGEX_PATTERN, {
      message: <Translation>{(t) => t('VALIDATE.VALID_LONGITUDE')}</Translation>,
    }),
  latitude: Yup.string()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_LATITUDE')}</Translation>)
    .matches(LATITUDE_REGEX_PATTERN, {
      message: <Translation>{(t) => t('VALIDATE.VALID_LATITUDE')}</Translation>,
    }),
})

export default PosCreateSchema
